<template>
  <v-menu offset-y bottom :close-on-content-click="false" v-if="nextWorkflowStatus.length > 1">
    <template v-slot:activator="{ on, attrs }">
      <slot :attrs="attrs" :on="on" :clickEvent="() => undefined" />
    </template>

    <v-list>
      <v-list-item
        v-for="workflowStatus in nextWorkflowStatus"
        :key="workflowStatus.id"
        @click.stop="changeStatus(workflowStatus)"
        :disabled="disabled"
      >
        <v-list-item-title>
          {{ workflowStatus.actionName }}
        </v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>

  <v-tooltip top v-else>
    <template v-slot:activator="{ on, attrs }">
      <slot
        :attrs="attrs"
        :on="on"
        :disabled="!firstNextWorkflowStatus || disabled"
        :clickEvent="() => changeStatus(firstNextWorkflowStatus)"
      />
    </template>

    <span v-if="firstNextWorkflowStatus">{{ firstNextWorkflowStatus.actionName }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: "MedicalRequestNextWorkflow",
    props: {
      nextWorkflowStatus: Array,
      changeStatus: Function,
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      firstNextWorkflowStatus() {
        return this.lodash.first(this.nextWorkflowStatus);
      },
    },
  };
</script>

<style lang="scss" scoped></style>
